export default "__VITE_ASSET__C5M6f5ec__"